import { render, staticRenderFns } from "./LandAdd.vue?vue&type=template&id=cd9474ac&scoped=true&"
import script from "./LandAdd.vue?vue&type=script&lang=js&"
export * from "./LandAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd9474ac",
  null
  
)

export default component.exports